import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import { leasingServiceTypeFragment, leasingServiceTypeLinkingFragment } from './fragments';

export const LEASING_SERVICE_TYPE_SAVED = gql`
  subscription leasingServiceTypeSaved {
    leasingServiceTypeSaved {
      leasingServiceType {
        ...leasingServiceType
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
  ${leasingServiceTypeFragment}
`;

export const LEASING_SERVICE_TYPE_DELETED = gql`
  subscription leasingServiceTypeDeleted($id: Int!) {
    leasingServiceTypeDeleted(id: $id) {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;

export const LEASING_SERVICE_TYPE_LINKINGS_SAVED = gql`
  subscription leasingServiceTypeLinkingsSaved {
    leasingServiceTypeLinkingsSaved {
      typeLinkings {
        ...leasingServiceTypeLinking
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${leasingServiceTypeLinkingFragment}
  ${CommonFragments.messageHeaders}
`;
